export type MediaConfig = { [breakpoint: string]: string };

export const MEDIA_BREAKPOINTS: MediaConfig = {
  XS: '(max-width: 480px)',
  SM: '(min-width: 480px) and (max-width: 767px)',
  MD: '(min-width: 768px) and (max-width: 1023px)',
  LG: '(min-width: 1024px) and (max-width: 1279px)',
  XL: '(min-width: 1280px)',
};
